define('view/controller/booking/details/BookingLeaveConfirmationView',['require','lib/view/LayoutView','lib/view/FormView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var FormView = require('lib/view/FormView');

    /**
     * Booking leave confirmation view
     *
     * @class BookingLeaveConfirmationView
     */
    return LayoutView.extend({

        template: '#booking_leave_confirmation',

        ui: {
            cancelBtn: '#sb_leave_cancel',
            confirmBtn: '#sb_leave_confirm',
        },

        events: {
            'click @ui.confirmBtn': 'performConfirm'
        },
        
        performConfirm: function () {
            this.triggerMethod('confirm');
        }

    });

});
